import React from 'react';

const Success = () => {
  return (
    <div>
      <h1>Pagamento realizado com sucesso!</h1>
      <p>Obrigado por sua compra. Seu pedido foi processado com sucesso.</p>
    </div>
  );
};

export default Success;